<div class="expired">
  <div class="expired-content">
    <img src="assets/media/icons/alert.gif" alt="Subscription expired alert" class="alert-gif" />
    <p class="message">
      {{ 'AUTH.SUBSCRIPTION.EXPIRED' | translate }}<br />
      {{ 'AUTH.SUBSCRIPTION.RENEW' | translate }}
    </p>
  </div>
</div>